import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ResetPasswordParams } from 'globals/types';
import { steps } from './ResetPassword.utils';

const ResetPassword: React.FC = () => {
  const { id: idFromEmail } = useParams<ResetPasswordParams>();
  const minStep = idFromEmail === '123' ? 3 : 1;
  const [currentStepIdx, setCurrentStepIdx] = useState<number>(minStep);

  const moveToNextStep = () => {
    setCurrentStepIdx((idx) => Math.min(idx + 1, steps.length));
  };

  return (
    <>
      {steps.map(
        ({ stepId, Component }) =>
          currentStepIdx === stepId && (
            <Component key={stepId} onGoNext={moveToNextStep} />
          )
      )}
    </>
  );
};

export default ResetPassword;
